import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import NumbersTwilioForm from './NumbersTwilioForm'
import { push } from 'react-router-redux'
import { createNumber } from 'features/Numbers/Numbers.actions'

const stateToProps = ({ form, auth }, { numberType, initialSearchValue }) => {
  const formName = 'numbersTwilio'
  return {
    isLoggedIn: !!auth.token,
    form: formName,
    formData: get(form, `${formName}.values`, {}),
    numberType,
    initialValues: {
      step: 0,
      ban: undefined,
      number: undefined,
      usagePlanAlias: `twilio-${numberType}`,
      customerReference: undefined,
      filter: {
        contains: initialSearchValue,
      },
      endUserType: undefined,
      uploadedFiles: [],
      callForwardingNumber: auth.user.phone,
      smsForwardingEmail: auth.user.username,
      isLoading: false,
    },
  }
}

const dispatchToProps = {
  createNumber,
  push,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  })(NumbersTwilioForm)
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersTwilioForm/NumbersTwilioForm.container.js